import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import { keyDown } from '../../utils/helpers';

interface StyledContainer {
  showLink: boolean;
}

const StyledContainerLink = styled.a`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const StyledOuterContainer = styled.div`
  padding: 30px 20px 20px 20px;
`;

const StyledContainer = styled.div<StyledContainer>`
  outline: none;
  border-radius: 4px;
  box-shadow: 0 8px 8px 0 rgba(45, 57, 64, 0.06), 0 0 4px 0 rgba(45, 57, 64, 0.06);
  background-color: ${tokens.ColorWhite000};
  height: fit-content;
  cursor: pointer;
  ${(props: any) =>
    props.showLink &&
    css`
      margin-top: -27px;
    `}
  transition: 0.5s;
  :hover {
    box-shadow: 0px 24px 24px rgba(45, 57, 64, 0.08), 0px 0px 12px rgba(45, 57, 64, 0.06);
    transform: translateY(0);
  }
`;

const StyledHeader = styled.div`
  font-family: Nimbus Sans Bold;
  background-color: ${tokens.ColorChartingBlue100};
  height: 36px;
  padding: 8px 24px 8px 24px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 1.67px;
  color: ${tokens.ColorBrandInteractiveBlueHover};
  border-radius: 4px 4px 0px 0px;
`;

const StyledBody = styled.div`
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorGrey800};
  height: 108px;
  padding: 24px;
  font-size: 16px;
  line-height: 1.38;
  a {
    color: ${tokens.ColorBrandInteractiveBlueHover};
  }
`;
const StyledSubheader = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: -0.5px;
  margin-bottom: 4px;
  @media (max-width: 768px) {
    font-size: 16px;
    letter-spacing: 0;
  }
`;

const StyledLink = styled.div`
  height: 54px;
  box-shadow: inset 0 1px 0 0 ${tokens.ColorWhite200};
  background-color: rgba(0, 104, 148, 0.04);
  font-size: 16px;
  line-height: 1.38;
  letter-spacing: normal;
  color: #006894;
  padding: 16px 24px;
  transition: 0.5s;
  transform: translateY(0);
  animation-delay: 1s;

  :hover {
    background-color: rgba(0, 104, 148, 0.08);
  }
`;

interface Props {
  tileHeader: string;
  tileSubheader: string;
  tileCopy: string;
  tileOnClick: () => void;
  linkText: string;
  handleLinkClick: () => void;
  analyticsId: string;
}

class ActionTile extends Component<Props> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = {
      showLink: false,
    };
  }

  handleKeyPress = (e: any) => {
    const { tileOnClick } = this.props;
    if (e.nativeEvent.code === 'Enter') {
      tileOnClick();
    }
  };

  render(): JSX.Element {
    const { tileHeader, tileSubheader, tileCopy, tileOnClick, linkText, handleLinkClick, analyticsId, id } = this.props;
    const { showLink } = this.state;
    const mq = window.matchMedia('(max-width: 1024px)');
    return (
      <StyledOuterContainer id={id + `-outer-container`}>
        <StyledContainer
          id={id + `-container`}
          tabIndex={0}
          onMouseEnter={() => this.setState({ showLink: true })}
          onMouseLeave={() => this.setState({ showLink: false })}
          onFocus={() => this.setState({ showLink: true })}
          onBlur={() => this.setState({ showLink: false })}
          showLink={showLink}
        >
          <StyledContainerLink
            id={id + `-container-link`}
            tabIndex={0}
            onClick={tileOnClick}
            onKeyPress={this.handleKeyPress}
          >
            {' '}
            <StyledHeader id={id + `-head`}>{tileHeader.toUpperCase()}</StyledHeader>
            <StyledBody id={id + `-body`}>
              <StyledSubheader id={id + `-sub-head`}>{tileSubheader}</StyledSubheader>
              <div dangerouslySetInnerHTML={{ __html: tileCopy }}></div>
            </StyledBody>
          </StyledContainerLink>
          {(mq.matches || showLink) && (
            <StyledLink id={id + `-link`}>
              <Link
                linkLabel={linkText}
                color={tokens.ColorBrandInteractiveBlue}
                hoverColor={tokens.ColorBrandInteractiveBlueHover}
                onClick={handleLinkClick}
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, handleLinkClick)}
                id={analyticsId}
              />
            </StyledLink>
          )}
        </StyledContainer>
      </StyledOuterContainer>
    );
  }
}

export default connect(null, {
  showModal: modalActions.showModal,
})(ActionTile);
